import { Modal } from 'bootstrap';

const popUp = document.getElementById('pop-up-modal');

if (popUp) {
    const modal = new Modal(document.getElementById('pop-up-modal'));
    const title = modal._element.getAttribute('title').replace(/\s/g, '');
    const popUpShowed = sessionStorage.getItem(`pop-up-${title}`);

    if (popUpShowed === null) {
        modal.show();

        sessionStorage.setItem(`pop-up-${title}`, true);
    }
}
